import React from 'react';
import { BrandIntro } from '../components/about/BrandIntro';
import { Timeline } from '../components/about/Timeline';
import { OurValues } from '../components/about/OurValues';
import { KeyPillars } from '../components/about/KeyPillars';
import { AboutCTA } from '../components/about/AboutCTA';
import { PageHero } from '../components/shared/PageHero';
import { useSEO } from '../hooks/useSEO';

export default function About() {
  useSEO({
    title: 'Sobre Nosotros',
    description: 'Nacimos para hacer tu día a día más fácil. Conoce la historia, misión y valores de ZWheel.',
    keywords: 'zwheel historia, valores marca, movilidad sostenible'
  });

  return (
    <div className="bg-white">
      {/* Page Hero - 统一的页面头部 */}
      <PageHero
        title="ZWheel"
        subtitle="Nacimos para hacer tu día a día más fácil"
      />

      {/* 3.1: Brand Intro & History - 我们的历史 */}
      <BrandIntro />

      {/* 3.2: Our Values - 我们的价值观 */}
      <OurValues />

      {/* 3.3: Timeline - 时间轴 */}
      <Timeline />

      {/* 3.4: Key Pillars - 关键词 */}
      <KeyPillars />

      {/* CTA */}
      <AboutCTA />
    </div>
  );
}
